// <cart-promo-countdown> — compact countdown for the cart promo card.
// data-deadline accepts "YYYY-MM-DD HH:MM" (local time) or "YYYY-MM-DD".
// Shows "Xd HH:MM:SS" (days only when > 0). Hides itself once the promo ends.
if (!customElements.get('cart-promo-countdown')) {
  class CartPromoCountdown extends HTMLElement {
    connectedCallback() {
      this.display = this.querySelector('[data-countdown]');
      if (!this.display) return;

      this.deadline = this.parse((this.getAttribute('data-deadline') || '').trim());
      if (!this.deadline) {
        this.style.display = 'none';
        return;
      }

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    parse(value) {
      const m = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
      if (m) {
        return new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59), 0).getTime();
      }
      const fallback = Date.parse(value);
      return Number.isNaN(fallback) ? null : fallback;
    }

    tick() {
      const remaining = this.deadline - Date.now();
      if (remaining <= 0) {
        clearInterval(this.interval);
        this.style.display = 'none';
        return;
      }
      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const pad = n => String(n).padStart(2, '0');
      this.display.textContent =
        (days > 0 ? days + 'd ' : '') + `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }
  }

  customElements.define('cart-promo-countdown', CartPromoCountdown);
}
